import { render } from "./YoutubeVideo.vue?vue&type=template&id=23806b21&scoped=true"
import script from "./YoutubeVideo.vue?vue&type=script&lang=js"
export * from "./YoutubeVideo.vue?vue&type=script&lang=js"

import "./YoutubeVideo.vue?vue&type=style&index=0&id=23806b21&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23806b21"]])

export default __exports__